import { Swiper } from './swiper-DDnfT8S0.js';
import { N as Navigation } from './navigation-DWrRZ7mI.js';
import { P as Pagination } from './pagination-BF_S6uBm.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class FeaturedCollections extends HTMLElement {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Pagination, Navigation],
      slidesPerView: 1.35,
      spaceBetween: 16,
      navigation: {
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4.08,
        },
      },
    });
  }
}

customElements.define('featured-collections', FeaturedCollections);
